
<template>
  <div class="adv-carusiel">
    <div class="grid-adv is-desctop" style="">
      <div class="left-photo">
        <v-avatar size="250" v-on:click="changeBannerAdv(false)" style="cursor:pointer">
          <v-img :lazy-src="customer1" :src="adv[advBefore].photo ? `${getApi}file/${adv[advBefore].photo}` : customer1"  />
        </v-avatar>
      </div>
      <div>
        <div class="center-wrapper">
          <img
            class="control-adv__left"
            v-on:click="changeBannerAdv(false)"
            src="/static/img/adv-left.svg" />
          <v-avatar size="350">
            <v-img :lazy-src="customer1" :src="adv[advThis].photo ? `${getApi}file/${adv[advThis].photo}` : customer1"  />
          </v-avatar>
          <img
            class="control-adv__rigth"
            v-on:click="changeBannerAdv(true)"
            src="/static/img/adv-right.svg"/>
        </div>
        <div class="info-on-this">
          <div>
            <span class="name">
              {{adv[advThis].surname}} {{adv[advThis].name}} {{adv[advThis].patronymic}}
            </span>
            <div>
              <div class="gray-text">
                Опыт работы: <span class="val-text">{{ adv[advThis].experience }}</span> лет
              </div>
              <!-- <div>
                Возраст: {{adv[advThis].old}}
              </div> -->
            </div>
            <div style="text-align: -webkit-center;">
              <div class="button-wrapper">
                <ui_btn type="main-btn full-width" @click="toProfile(adv[advThis])" >Написать</ui_btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-photo">
        <v-avatar size="250" style="cursor: pointer" v-on:click="changeBannerAdv(true)">
          <v-img :lazy-src="customer1" :src="adv[advLate].photo ? `${getApi}file/${adv[advLate].photo}` : customer1"  />
        </v-avatar>
      </div>
    </div>
    <div class="is-mobile mobile-wrapper">
      <v-avatar size="150" v-on:click="changeBannerAdv(false)" style="cursor:pointer">
        <v-img class="small-img" :lazy-src="customer1" :src="adv[advBefore].photo ? `${getApi}file/${adv[advBefore].photo}` : customer1"  />
      </v-avatar>
      <v-avatar class="av-center" size="223">
        <v-img :lazy-src="customer1" :src="adv[advThis].photo ? `${getApi}file/${adv[advThis].photo}` : customer1"  />
      </v-avatar>
      <v-avatar size="150" style="cursor: pointer" v-on:click="changeBannerAdv(true)">
        <v-img class="small-img" :lazy-src="customer1" :src="adv[advLate].photo ? `${getApi}file/${adv[advLate].photo}` : customer1"  />
      </v-avatar>
    </div>
    <div class="is-mobile mobile-info-on-this">
      <div style="text-align: -webkit-center; margin-top: 1em;">
        <span class="name">
          {{adv[advThis].surname}} {{adv[advThis].name}} {{adv[advThis].patronymic}}
        </span>
        <div>
          <div class="gray-text">
            Опыт работы: <span class="val-text">{{ adv[advThis].experience }}</span> лет
          </div>
        </div>
        <div class="action-button">
          <img
            style="width: 34px; height: 34px;"
            class="control-adv__left"
            v-on:click="changeBannerAdv(false)"
            src="/static/img/adv-left.svg" />
          <img
            style="width: 34px; height: 34px;"
            class="control-adv__rigth"
            v-on:click="changeBannerAdv(true)"
            src="/static/img/adv-right.svg"/>
        </div>
        <div style="text-align: -webkit-center;">
          <div class="button-wrapper">
            <ui_btn type="main-btn" @click="toProfile(adv[advThis])" >Написать</ui_btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UiBtn from './ui/UiBtn.vue'
export default {
  components: { UiBtn },

  name: 'advCarusiel',

  props: {
    adv: {
      default: []
    }
  },

  data: () => ({
    customer1: "/static/img/customer1.png",
    advBefore: 0,
    advLate: 2,
    advThis: 1
  }),
  
  computed: {
    ...mapGetters(['getApi'])
  },

  methods: {
    toProfile(item){
      this.$router.push({ path: 'profile', query: { id: item.uid }})
    },
    changeBannerAdv(value){
      let total = this.adv.length
      if(value) {
        if(this.advThis === (total-1)){
          this.advThis = 0
        }else{
          this.advThis = this.advThis + 1
        }
        if(this.adv[this.advThis - 1]){
          this.advBefore = this.advThis - 1
        }else{
          this.advBefore  = total - 1
        }
        if(this.adv[this.advThis + 1]){
          this.advLate = this.advThis + 1
        }else{
          this.advLate  = 0
        }
      }
      else{
        if(this.advThis === 0){
          this.advThis = total - 1
        }else{
          this.advThis = this.advThis - 1
        }
        if(this.adv[this.advThis - 1]){
          this.advBefore = this.advThis - 1
        }else{
          this.advBefore  = total - 1
        }
        if(this.adv[this.advThis + 1]){
          this.advLate = this.advThis + 1
        }else{
          this.advLate  = 0
        }
      }

    },
  }
}
</script>

<style>
  .left-photo{
    width: 100%;
    text-align: -webkit-right;
  }
  .right-photo{
    width: 100%;
    text-align: -webkit-left;
  }
  .grid-adv{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 21px;
    align-items: center;
    justify-items: center;
  }
  .adv-carusiel .grid-adv .center-wrapper{
    display: flex;
  }
  .adv-carusiel .grid-adv .center-wrapper .control-adv__left{
    margin-right: 50px;
  }
  .adv-carusiel .grid-adv .center-wrapper .control-adv__rigth{
    margin-left: 50px;
  }
  .adv-carusiel .grid-adv .info-on-this .name{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 27px;
    line-height: 37px;
    text-align: center;
    
    color: #000000;
  }
  .adv-carusiel .grid-adv .info-on-this .gray-text{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 21px;
    
    color: #808080;
  }
  .adv-carusiel .grid-adv .info-on-this .val-text{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 21px;
    
    color: #000000;
  }
  .info-on-this{
    display: flex;
    margin-top: 20px;
    justify-content: center;
  }
  .info-on-this .button-wrapper{
    width: 338px;
    margin: 56px 0;
  }
  @media (min-width: 850px) {
    .adv-carusiel{
      overflow: auto;
    }
  }
  @media (max-width: 850px) {
    .mobile-info-on-this .gray-text{
      font-family: 'Helvetica';
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 21px;
      letter-spacing: 0.07em;
      color: #808080;
    }
    .mobile-info-on-this .val-text{
      font-family: 'Helvetica';
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 21px;
      letter-spacing: 0.07em;
      color: #000000;
    }
    .mobile-wrapper .small-img .v-image__image{
      filter: blur(2px); 
    }
    .mobile-wrapper .v-avatar:first-child{
      left: 0;
      text-align: center;
      position: absolute;
    }
    .av-center{
      z-index: 10;
    }
    .mobile-wrapper .v-avatar:last-child{
      right: 0;
      text-align: center;
      position: absolute;
    }
    .mobile-wrapper {
      margin: 0 15px;
      display: flex;
      align-items: center;
      position: relative;
      justify-content: center;
    }
    .mobile-info-on-this{
      margin: 0 15px;
    }
    .mobile-info-on-this .name {
      font-family: 'Helvetica';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #000000;
    }
    .action-button{
      display: flex;
      justify-content: space-between;
    }
  }
</style>



// WEBPACK FOOTER //
// advCarusiel.vue?3ae54ef4